import React from "react";
import { Handle } from "reactflow";

const CustomSwitchNode = ({ data }) => {
  const { label, isOn, toggleSwitch } = data;

  return (
    <div
      // style={{
      //   display: "flex",
      //   flexDirection: "column",
      //   alignItems: "center",
      //   justifyContent: "center",
      //   width: "100px", // Explicit width
      //   height: "60px", // Explicit height
      //   border: "none", // Remove default borders
      //   borderRadius: "10px",
      //   backgroundColor: isOn ? "#4caf50" : "#f44336", // Green for ON, Red for OFF
      //   color: "white",
      //   cursor: "pointer",
      //   textAlign: "center",
      //   position: "relative", // Required for Handle positioning
      // }}
      className="flex flex-col m-auto items-center justify-center relative bg-gray-800 h-[50px] w-[50px] rounded-md"
      // onClick={toggleSwitch}
    >
      {/* Output Handle for Edge Connections */}
      <Handle
        type="source"
        position="top"
        style={{
          background: "#fff",
          borderRadius: "50%",
          width: "10px",
          height: "10px",
          top: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      />
      {/* Switch Label */}
      {/* <div style={{ fontWeight: "bold", marginBottom: "5px" }}>{label}</div> */}
      {/* Switch Toggle */}
      {/* <div
        style={{
          width: "40px",
          height: "20px",
          borderRadius: "10px",
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: isOn ? "flex-end" : "flex-start",
          alignItems: "center",
          padding: "2px",
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            width: "15px",
            height: "15px",
            borderRadius: "50%",
            backgroundColor: isOn ? "#4caf50" : "#f44336",
          }}
        ></div>
      </div> */}
      <div
        className={`${
          isOn ? "bg-red-600" : "bg-red-950"
        } h-[35px] w-[35px] rounded-full cursor-pointer`}
        onClick={toggleSwitch}
      ></div>
    </div>
  );
};

export default CustomSwitchNode;
